import $axios from './apiConnection'
import axios, { AxiosRequestConfig } from 'axios'
import $axiosExternal from './apiConnectionExternal'
import parseCatch from '../helpers/handleErrors.js'
import momentTimezone from 'moment-timezone'
import { GmtOffsetTypes } from '@/enum/gmt'
import { ActiveDashboardData, ActiveDashboardDataConfig } from '@/composables/globalData/useDashoardsData'
import { selectedAccountID } from '@/composables/globalData/useEntitiesData'
import { GmtoffsetData } from '@/types/dashboard'
import { getEntityList } from '@/composables/globalData/useEntitiesData'

export function getDashboardGMTConfig (): GmtoffsetData {
    const dashboardStore = ActiveDashboardData.value

    return dashboardStore?.DashboardConf && 'GMTOffsetData' in dashboardStore.DashboardConf ? dashboardStore.DashboardConf.GMTOffsetData : {
        Type: GmtOffsetTypes.Browser
    }
}

export function getGmtOffset () {
    const GMTOffsetData = getDashboardGMTConfig()

    if (GMTOffsetData.Type === GmtOffsetTypes.Account) {
        const allAccounts =  getEntityList('Accounts')
        const currentAccount = allAccounts.find(el => el.AccountID === Number(GMTOffsetData.AccountID))
        return currentAccount?.GmtOffset
    } else if (GMTOffsetData.Type === GmtOffsetTypes.Browser) {
        return new Date().getTimezoneOffset() * 60 * -1
    } else {
        const GMTOffset = momentTimezone().tz(GMTOffsetData.GMTOffset).utcOffset() * 3600
        return GMTOffset / 60
    }
}

export const WidgetDataApi = {
    async getData (endPoint: string, requestConfig = {}) {
        try {
            const DashboardConf = getDashboardGMTConfig()
            const config: AxiosRequestConfig = {
                ...requestConfig,
                headers: {
                    'x-GmtOffset': String(getGmtOffset()),
                    GmtOffsetType: DashboardConf.Type
                }
            }
            if(ActiveDashboardDataConfig.value?.getEntitiesFromSelectedAccount) {
                config.headers['X-Selected-Account'] = selectedAccountID.value
            }

            const res = await $axios.post(endPoint, {}, config)
            return res.Data
        } catch (e) {
            if (axios.isCancel(e)) {
                return
            }
            parseCatch(e, true)
            return Promise.reject(e)
        }
    },

    async getExternalData (endPoint: string, requestConfig = {}) {
        try {
            const res = await $axiosExternal.get(endPoint, requestConfig)

            if ('Data' in res) {
                return res.Data
            }

            return res
        } catch (e) {
            if (axios.isCancel(e)) {
                return
            }
            parseCatch(e, true)
        }
    }
}
